import {
  GET_PROFILE_DATA_SAGA,
  EDIT_PROFLIE_DATA_SAGA,
  SET_EXPIRATION_DATA,
} from "../actionTypes";

export const getProfileAction = () => {
  return {
    type: GET_PROFILE_DATA_SAGA,
  };
};

export const editProfileAction = (data) => {
  return {
    type: EDIT_PROFLIE_DATA_SAGA,
    payload: data,
  };
};
export const set_expiration_data_Action = (data) => {
  return {
    type: SET_EXPIRATION_DATA,
    payload: data,
  };
};
